import React, { useContext } from 'react';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Image, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { SideBarContext } from '../context/SideBarContext';
import { Widths } from '../utils/Enums/Common';
interface NavLinkProps {
    path: string;
    label: string;
    image?: string;
    icon?: IconDefinition;
    indicator?: React.ReactNode;
}

export const NavLink = ({ path, label, image, icon, indicator }: NavLinkProps) => {
    const screenWidth = window.innerWidth;
    const { setSideBarVissible } = useContext(SideBarContext);
    return (
        <Nav.Link
            as={Link}
            to={path}
            className='w-100'
            data-toggle='pill'
            onClick={() => {
                if (screenWidth < Widths.smallScreen) {
                    setSideBarVissible(false);
                }
            }}
        >
            {image ? (
                <Image fluid src={image}></Image>
            ) : (
                <div className='nav-menu-link d-flex align-items-center px-2 my-1 link color-main'>
                    {icon && <FontAwesomeIcon icon={icon} className='fa-fw nav-menu-link-icon' />}
                    <p className='m-0 fs-5 px-2 nav-menu-link-label'>{label}</p>
                    <span className='nav-menu-link-indicator'>{indicator}</span>
                </div>
            )}
        </Nav.Link>
    );
};
